import { useFormContextData, FormContext } from '@agtech/core/forms/AgTechFormContext';
import { AgTechFormProps } from '@agtech/core/forms/AgTechFormProps';
import { AgTechFormState } from '@agtech/core/forms/AgTechFormState';
import AgTechHeaderDetail from '../Headers/AgTechHeaderDetail';
import { AgTechWarningIcon, AgTechSuccessIcon } from '../Icons/AgTechIcons';
import React, { useEffect, useState } from 'react'

const AgTechFormComponent = <TFormData, TActionData, TResponseData, TContextData = TFormData>(
    props: AgTechFormProps<TFormData, TActionData, TResponseData, TContextData>
) => {
    const formContext = useFormContextData(props);

    return (
        <div className={`stretched row-based agtech-form flex ${props.structure?.classes ?? ''}`}>
            <FormContext.Provider value={formContext}>
                {props.structure?.header ? (
                    <AgTechHeaderDetail
                        header={props.structure.header.title}
                        settings={{
                            header: {
                                classes: 'text-lg font-semibold'
                            },
                            classes: 'mb-2',
                            content: {
                                body: () => (
                                    <div className='column-based-vertically-centered container'>
                                        {props.structure?.header?.content ? props.structure.header.content() : null}
                                        {props.behavior?.realtimeSubmissionProps ? <AgTechFormStateControl state={formContext.state}/> : null}
                                    </div>
                                )
                            }
                        }}
                    />
                ) : null}
                {typeof props.children === 'function' ? props.children(formContext) : props.children}
            </FormContext.Provider>
        </div>
    );
};

export const AgTechFormStateControl = (props: { state: AgTechFormState, classes?: string }) => {
    let [currentState, setCurrentState] = useState(props.state);

    useEffect(() => {
        if (props.state === AgTechFormState.Submitting) {
            setCurrentState(AgTechFormState.Submitting);
        }
        else if (props.state === AgTechFormState.Successful) {
            setTimeout(() => {
                setCurrentState(AgTechFormState.Successful);
            }, 1500);
        }
    }, [props.state]);

    return (
        <div className={`bg-white centered bordered rounded container ${props.classes ?? ''}`} style={{ height: 32, width: 36 }}>
            {currentState === AgTechFormState.Submitting ? <div className={`loader`} style={{ height: 16, width: 16 }} />
           : currentState === AgTechFormState.Failed ? <AgTechWarningIcon />
           : <AgTechSuccessIcon classes='agtech-fade-in font-size-large' />}
        </div>
    )
}

export const AgTechForm = React.memo(AgTechFormComponent, (prev, curr) => {
    return prev.contextualData === curr.contextualData;
}) as typeof AgTechFormComponent;